import amazon from "../../../../../assets/images/marketplaces/amazon.png";
import walmart from "../../../../../assets/images/marketplaces/walmart.png";
import woocommerce from "../../../../../assets/images/marketplaces/woocommerce.png";
import shopify from "../../../../../assets/images/marketplaces/shopify.png";
import ebay from "../../../../../assets/images/marketplaces/ebay.png";
import bestbuy from "../../../../../assets/images/marketplaces/bestbuy.png";
import etsy from "../../../../../assets/images/marketplaces/etsy.svg";
import tiktok from "../../../../../assets/images/marketplaces/tiktok.svg";
import canadiantire from "../../../../../assets/images/marketplaces/canadiantire.png";
import wayfair from "../../../../../assets/images/marketplaces/wayfair.png";
import newegg from "../../../../../assets/images/marketplaces/newegg.svg";
import faire from "../../../../../assets/images/marketplaces/faire.png";
import bigcommerce from "../../../../../assets/images/marketplaces/bigcommerce.svg";
import wix from "../../../../../assets/images/marketplaces/wix.svg";
import squarespace from "../../../../../assets/images/marketplaces/squarespace.svg";
import adobe from "../../../../../assets/images/marketplaces/adobe.svg";
import ecwid from "../../../../../assets/images/marketplaces/ecwid.png";
import square from "../../../../../assets/images/marketplaces/square.svg";
import prestashop from "../../../../../assets/images/marketplaces/prestashop.svg";
import lightspeed from "../../../../../assets/images/marketplaces/lightspeed.png";
import netsuite from "../../../../../assets/images/marketplaces/netsuite.ico";
import zoho from "../../../../../assets/images/marketplaces/zoho.svg";
import zapier from "../../../../../assets/images/marketplaces/zapier.svg";

export const SHOPIFY_APP_URL =
  "https://apps.shopify.com/hajex-bolt-shipping-solution";

export const isStoreActive = (store) =>
  [true, "true", "1", 1].includes(store.status);

// Shopify is the only channel that connects today (via its App Store app).
// Amazon, Walmart and WooCommerce integrations are paused and listed as
// coming soon; their old stores can still show in Connected stores.
export const LIVE_CHANNELS = [
  { key: "shopify", name: "Shopify", logo: shopify },
];

export const SOON_GROUPS = [
  {
    title: "Marketplaces",
    i18nKey: "marketplaces.soon.groups.marketplaces",
    items: [
      {
        key: "amazon",
        name: "Amazon",
        logo: amazon,
        desc: "Import Seller Central orders through the Selling Partner API.",
      },
      {
        key: "walmart",
        name: "Walmart",
        logo: walmart,
        desc: "Import Walmart Marketplace orders with your seller API keys.",
      },
      {
        key: "ebay",
        name: "eBay",
        logo: ebay,
        desc: "Import eBay orders and send tracking back to Seller Hub.",
      },
      {
        key: "bestbuy",
        name: "Best Buy",
        logo: bestbuy,
        desc: "Fulfil Best Buy Marketplace Canada orders from BOLT.",
      },
      {
        key: "etsy",
        name: "Etsy",
        logo: etsy,
        desc: "Pull Etsy orders into BOLT and mark them shipped with tracking.",
      },
      {
        key: "tiktok",
        name: "TikTok Shop",
        logo: tiktok,
        desc: "Fulfil TikTok Shop orders alongside every other channel.",
      },
      {
        key: "canadiantire",
        name: "Canadian Tire Marketplace",
        logo: canadiantire,
        desc: "Fulfil Canadian Tire Marketplace orders and confirm shipment with tracking.",
      },
      {
        key: "wayfair",
        name: "Wayfair",
        logo: wayfair,
        desc: "Import Wayfair dropship purchase orders and return tracking.",
      },
      {
        key: "newegg",
        name: "Newegg",
        logo: newegg,
        desc: "Pull Newegg Marketplace orders into BOLT and mark them shipped.",
      },
      {
        key: "faire",
        name: "Faire",
        logo: faire,
        desc: "Ship wholesale orders from Faire retailers through BOLT.",
      },
    ],
  },
  {
    title: "Storefronts & carts",
    i18nKey: "marketplaces.soon.groups.storefronts",
    items: [
      {
        key: "woocommerce",
        name: "WooCommerce",
        logo: woocommerce,
        desc: "Sync orders from your WordPress store with the Hajex plugin.",
      },
      {
        key: "bigcommerce",
        name: "BigCommerce",
        logo: bigcommerce,
        desc: "Import BigCommerce orders and push tracking back automatically.",
      },
      {
        key: "wix",
        name: "Wix",
        logo: wix,
        desc: "Sync Wix Stores orders straight into your shipping queue.",
      },
      {
        key: "squarespace",
        name: "Squarespace",
        logo: squarespace,
        desc: "Bring Squarespace Commerce orders into BOLT without CSVs.",
      },
      {
        key: "adobe",
        name: "Adobe Commerce",
        logo: adobe,
        desc: "Connect Magento / Adobe Commerce stores through a BOLT extension.",
      },
      {
        key: "ecwid",
        name: "Ecwid",
        logo: ecwid,
        desc: "Import Ecwid by Lightspeed orders and sync tracking.",
      },
      {
        key: "square",
        name: "Square",
        logo: square,
        desc: "Ship Square Online and Square POS orders from one queue.",
      },
      {
        key: "prestashop",
        name: "PrestaShop",
        logo: prestashop,
        desc: "Connect PrestaShop stores through a BOLT module.",
      },
    ],
  },
  {
    title: "POS, ERP & automation",
    i18nKey: "marketplaces.soon.groups.pos",
    items: [
      {
        key: "lightspeed",
        name: "Lightspeed Retail",
        logo: lightspeed,
        desc: "Ship Lightspeed Retail web and special orders from BOLT.",
      },
      {
        key: "netsuite",
        name: "NetSuite",
        logo: netsuite,
        desc: "Send NetSuite sales orders to BOLT and write tracking back to fulfilments.",
      },
      {
        key: "zoho",
        name: "Zoho Inventory",
        logo: zoho,
        desc: "Sync Zoho Inventory sales orders and package status.",
      },
      {
        key: "zapier",
        name: "Zapier",
        logo: zapier,
        desc: "Create BOLT shipments from thousands of apps — no code.",
      },
    ],
  },
];

export const SOON_COUNT = SOON_GROUPS.reduce((n, g) => n + g.items.length, 0);

// Every known channel, so stores from paused integrations still render with
// their logo and name.
export const CHANNELS_BY_KEY = Object.fromEntries(
  [...LIVE_CHANNELS, ...SOON_GROUPS.flatMap((g) => g.items)].map((c) => [
    c.key,
    c,
  ]),
);
